<template>
  <div class="w-100">
    <b-row v-if="left" class="who-block left">
      <b-col cols="12" md="5" class="text-content">
        <Icon :color="iconColor" :stroke="false" :icon="icon" :width="80" :height="80" />
        <h2 class="title">{{ $t(title) }}</h2>
        <h3 class="sub-title">{{ $t(subTitle) }}</h3>
        <p>{{ $t(content) }}</p>
      </b-col>
      <b-col cols="12" md="7">
        <img
          :src="urlImg"
          :alt="$t('enterprise.index.whosVexels.whoIsVexelsImageAlt')"
          class="w-100"
          loading="lazy"
        />
      </b-col>
    </b-row>
    <b-row v-else class="who-block right">
      <b-col cols="12" md="7">
        <img
          :src="urlImg"
          :alt="$t('enterprise.index.whosVexels.whoIsVexelsImageAlt')"
          class="w-100"
          loading="lazy"
        />
      </b-col>
      <b-col cols="12" md="5" class="text-content">
        <Icon :color="iconColor" :stroke="false" :icon="icon" :width="80" :height="80" />
        <h2 class="title">{{ $t(title) }}</h2>
        <h3 class="sub-title">{{ $t(subTitle) }}</h3>
        <p>{{ $t(content) }}</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Icon from 'UI/Icon';

export default {
  name: 'WhoBlock',
  components: {
    Icon
  },
  props: {
    left: {
      type: Boolean,
      required: false,
      default: true
    },
    urlImg: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    iconColor: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss">
/* Style is not scoped because the video loaded separately */
.who-block {
  margin: 100px 0;
  .text-content {
    color: #474747;
    > .title {
      margin: 20px 0;
      font-size: 40px;
      width: 70%;
      font-weight: 500;
    }
    > .sub-title {
      font-size: 22px;
      margin: 20px 0;
    }
    > p {
      font-size: 15px;
      line-height: 30px;
    }
  }
  &.left .text-content {
    padding-right: 10%;
    @include md {
      padding-right: 15px;
      margin-bottom: 30px;
    }
  }
  &.right {
    @include md {
      flex-flow: wrap-reverse;
    }
    .text-content {
      padding-left: 10%;
      @include md {
        padding-left: 15px;
        margin-bottom: 30px;
      }
    }
  }
}
</style>
